import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, ref } from "vue";
  import { QInput } from "quasar";


  
export default /*@__PURE__*/_defineComponent({
  __name: 'CurrencyInput',
  props: {
    modelValue: {
      type: Number as () => number | null,
      default: null
    },
    placeholder: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: null
    },
    hidePrefix: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'update:modelValue'
  ],
  setup(__props, { expose: __expose, emit: __emit }) {

  const props = __props

  const rules = computed(() => [
    (val: number) => (props.required && !!val) || !props.required || "Required",
    (val: number) => (val >= props.min) || `Must be greater than ${props.min}`,
    (val: number) => !props.max || (props.max !== null && val <= props.max) || `Must be less than ${props.max}`
  ])

  const value = computed<number | null>({
    get() {
      return props.modelValue
    },
    set(value: number | null) {
      emit('update:modelValue', value)
    }
  })

  const emit = __emit
  
  const currencyInputRef = ref<QInput | null>(null);
  
  function validate() {
    const valid = currencyInputRef.value!.validate();
    return valid;
  }

  __expose({
    validate
  })

  function onBlur(event: Event) {
    if ((event.target! as HTMLInputElement).value === "") {
      emit('update:modelValue', props.min || props.min === 0 ? props.min : '')
    }
  }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(_unref(QInput), {
      outlined: "",
      dense: "",
      ref_key: "currencyInputRef",
      ref: currencyInputRef,
      modelValue: value.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      modelModifiers: { number: true },
      pattern: "[0-9]",
      onBlur: onBlur,
      min: __props.min,
      max: __props.max,
      type: "tel",
      "bg-color": "white",
      placeholder: __props.placeholder,
      rules: rules.value,
      "lazy-rules": "",
      prefix: __props.hidePrefix ? '' : '£'
    }, null, 8, ["modelValue", "min", "max", "placeholder", "rules", "prefix"])
  ], 64))
}
}

})